import React, { useState } from 'react';
import { Button } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

const ConsentModal = ({ t, onAccept, onCancel }) => {
  const [consentChecked, setConsentChecked] = useState(false);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center gap-3 mb-4">
            <AlertCircle className="h-8 w-8 text-orange-500" />
            <h2 className="text-2xl font-bold text-gray-900">
              {t.labConsentTitle}
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-4 mb-6">
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-purple-600 font-bold mt-1">•</span>
                  <span>{t.labConsentLine1}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-purple-600 font-bold mt-1">•</span>
                  <span>{t.labConsentLine2}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-purple-600 font-bold mt-1">•</span>
                  <span>{t.labConsentLine3}</span>
                </li>
              </ul>
            </div>

            {/* Checkbox */}
            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border-2 border-gray-200">
              <input
                type="checkbox"
                id="consent-checkbox"
                checked={consentChecked}
                onChange={(e) => setConsentChecked(e.target.checked)}
                className="w-5 h-5 mt-0.5 rounded cursor-pointer"
              />
              <label
                htmlFor="consent-checkbox"
                className="text-gray-900 font-medium cursor-pointer flex-1"
              >
                {t.labConsentCheckbox}
              </label>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 px-6 py-3 bg-gray-200 text-gray-700 font-semibold rounded-xl hover:bg-gray-300 transition-colors"
            >
              {t.labActionsCancel}
            </button>
            <button
              onClick={onAccept}
              disabled={!consentChecked}
              className={`flex-1 px-6 py-3 font-semibold rounded-xl transition-colors ${
                consentChecked
                  ? 'bg-purple-600 text-white hover:bg-purple-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              {t.labActionsEnableLab}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
